import { render } from "./PdfChip.vue?vue&type=template&id=439d0fb7&scoped=true&ts=true"
import script from "./PdfChip.vue?vue&type=script&lang=ts"
export * from "./PdfChip.vue?vue&type=script&lang=ts"

import "./PdfChip.vue?vue&type=style&index=0&id=439d0fb7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439d0fb7"]])

export default __exports__